import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import Title from "../../../components/common/Title/Title";
import TextFiled from "../../../components/common/InputField/TextFiled";
import MainButton from "../../../components/common/MainButton/MainButton";
import ButtonText from "../../../components/common/Typography/ButtonText";
import Heading from "../../../components/common/Typography/Heading";
import Paragraph from "../../../components/common/Typography/Paragraph";
import AuxiliaryText from "../../../components/common/Typography/AuxiliaryText";
import Spinner from "../../../components/common/Spinner";
import InteractiveText from "../../../components/common/Typography/InteractiveText";
import SpecialText from "../../../components/common/Typography/SpecialText";
import { setField, setStep } from "../../../Redux/Slice/SignUp";
import { setFile, setError, clearFile } from "../../../Redux/Slice/FileUpload";
import { LocationSchema } from "../../../FormValidations/SignUpSchema";
import { UpdateUserMutation } from "../../../services/SignUp";
import { useGraphQL } from "../../../context/GraphQLProvider";
import ImageCropper from "../../../components/common/ImageCropper/ImageCropper";
import Modal from "../../../components/common/Modal/Modal";
import Alerts from "../../../components/common/Alerts/Alerts";
import { validateFile, getAcceptAttribute } from "../../../utils/contentSafety";
import { transformToUserInput } from "../../../utils/userInputUtils";
import StepBackButton from "../../../components/common/StepBackButton/StepBackButton";
import { FileUploadQuery } from "../../../services/FileUploadService";
import { POPUP_FORM_CONTENT_CLASS } from "../../../components/popup/popupLayoutSpec";

const AddProfilePicture = ({ onClickHandler }) => {
    const graphqlService = useGraphQL();
    const [RequestStart, setRequetStart] = useState(false);
    const dispatch = useDispatch();
    // Temporarily disabled cropping state
    // const [showCropper, setShowCropper] = useState(false);
    // const [selectedFile, setSelectedFile] = useState(null);

    const InitialValues = useSelector((state) => state.signup);
    const { id, profilePicture, step } = useSelector((state) => state.signup);

    const handleFileInputChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;
        const result = validateFile(file, "image");
        if (!result.valid) {
            Alerts.error(result.message);
            e.target.value = "";
            return;
        }
        e.target.value = "";
        setRequetStart(true);
            try {
                // Upload the file directly without cropping
                const uploadResponse = await FileUploadQuery(graphqlService, { file: file });
                
                if (uploadResponse?.uploadFile?.success) {
                    const imageUrl = uploadResponse.uploadFile.url;
                    
                    // Update profile picture in Redux and database
                    dispatch(setField({profilePicture: imageUrl}));
                    const userInput = transformToUserInput(InitialValues);
                    userInput.userInput.profilePicture = imageUrl;

                    const response = await UpdateUserMutation(graphqlService, userInput);
                    if (response.updateUserProfile?.profilePicture === imageUrl) {
                        // Success - file uploaded without cropping
                        console.log('Profile picture uploaded successfully without cropping');
                    }
                } else {
                    Alerts.error(`Upload failed: ${uploadResponse?.uploadFile?.error || 'Unknown error'}`);
                }
            } catch (error) {
                Alerts.error(`Upload error: ${error.message}`);
            } finally {
                setRequetStart(false);
            }
    };

    // Temporarily disabled cropping functions
    // const handleModalClose = () => {
    //     setShowCropper(false);
    //     setSelectedFile(null);
    // };

    // const handleCropComplete = async (croppedImageBlob) => {
    //     setRequetStart(true);
    //     try {
    //         // Create a File object from the cropped blob
    //         const croppedFile = new File([croppedImageBlob], selectedFile.name, {
    //             type: croppedImageBlob.type,
    //             lastModified: Date.now(),
    //         });

    //         // Upload the cropped file
    //         const uploadResponse = await FileUploadQuery(graphqlService, { file: croppedFile });
            
    //         if (uploadResponse?.uploadFile?.success) {
    //             const imageUrl = uploadResponse.uploadFile.url;
                
    //             // Update profile picture in Redux and database
    //             dispatch(setField({profilePicture: imageUrl}));
    //             const userInput = transformToUserInput(InitialValues);
    //             userInput.userInput.profilePicture = imageUrl;

    //             const response = await UpdateUserMutation(graphqlService, userInput);
    //             if (response.updateUserProfile?.profilePicture === imageUrl) {
    //                 setShowCropper(false);
    //                 setSelectedFile(null);
    //             }
    //         } else {
    //             Alerts.error(`Upload failed: ${uploadResponse?.uploadFile?.error || 'Unknown error'}`);
    //         }
    //     } catch (error) {
    //         Alerts.error(`Upload error: ${error.message}`);
    //     } finally {
    //         setRequetStart(false);
    //     }
    // };

    return (
        <>
            {RequestStart && <Spinner />}
            <div className="overflow-auto relative flex items-center justify-center" style={{ minHeight: 'calc(100vh - 120px)' }}>
                <div className={POPUP_FORM_CONTENT_CLASS}>
                    <Heading
                        variant={"h6"}
                        className={"flex items-center justify-center text-center text-offblack"}
                    >
                        Add profile picture
                    </Heading>

                    <div className="mt-10 xl:mt-[60px] w-full">
                        <div className="flex justify-center w-full">
                            <div className="w-full mx-auto">
                                <div className="relative mx-auto flex justify-center">
                                    <div className={`avatar-display rounded-full ${profilePicture ? "" : "border border-solid border-[#C0C0C0] border-[1.4px]"}`}>
                                        {profilePicture && (
                                            <img
                                                className="object-cover object-center w-full h-full cursor-pointer rounded-full"
                                                src={profilePicture}
                                                alt={"custProfile"}
                                            />
                                        )}
                                        {!profilePicture && (
                                            <div className="object-center rounded-full w-full h-full cursor-pointer bg-white" />
                                        )}
                                    </div>
                                    <div className="absolute z-10 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                                        <div className={`flex justify-center items-center rounded-full size-[30px] pt-[2px] relative ${profilePicture && "bg-white"}`}>
                                            <div>
                                                <label role="button" className="flex justify-center bg-transparent">
                                                    <input
                                                        type="file"
                                                        accept={getAcceptAttribute("image")}
                                                        onChange={handleFileInputChange}
                                                        style={{ display: 'none' }}
                                                    />
                                                    {!profilePicture ? (
                                                        <Title text={"Upload"} width={"50"}>
                                                            <i className="fi fi-rs-upload text-base text-offblack hover:text-primaryblue"></i>
                                                        </Title>
                                                    ) : (
                                                        <Title text={"Edit"} width={"50"}>
                                                            <i className="fi fi-rs-pen-circle text-base text-offblack hover:text-primaryblue"></i>
                                                        </Title>
                                                    )}
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="flex justify-center w-full">
                            <div className="w-full mx-auto">
                                <div className="flex items-center justify-between mt-10 w-full">
                                    <StepBackButton onClick={() => dispatch(setStep(step - 1))} />
                                    <MainButton
                                        variant={"small"}
                                        onClick={onClickHandler}
                                    >
                                        Next
                                    </MainButton>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Temporarily disabled ImageCropper modal - cropping skipped */}
            {/* <Modal 
                isOpen={showCropper} 
                onClose={handleModalClose}
            >
                {selectedFile && (
                    <ImageCropper
                        image={URL.createObjectURL(selectedFile)}
                        onComplete={handleCropComplete}
                        onCancel={handleModalClose}
                    />
                )}
            </Modal> */}
        </>
    );
};

export default AddProfilePicture;
